import { CurrencyCode, CurrencyFormat, CurrencyLocale } from './currency.constants';
import { ICurrencyConfig } from './currency.types';

export const toCurrency = (value: number | undefined | null, config: ICurrencyConfig): string => {
  const {
    locale = CurrencyLocale.USD,
    currencyCode = CurrencyCode.USD,
    format = CurrencyFormat.Short,
    hasNegativeParens = false,
    placeholder = '$0.00',
    fractionDigits = config?.currencyCode === CurrencyCode.JPY ? undefined : 2,
  } = config || {};

  if (value == null) {
    return placeholder;
  }

  const valueToFormat = hasNegativeParens ? Math.abs(value) : value;
  let localizedCurrencyValue = new Intl.NumberFormat(locale, {
    style: format === CurrencyFormat.None ? 'decimal' : 'currency',
    currency: currencyCode,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
    currencyDisplay: format === CurrencyFormat.Long && ['fr-CA', 'zh-HK'].includes(locale) ? 'narrowSymbol' : undefined,
  }).format(valueToFormat);

  if (format === CurrencyFormat.Long) {
    localizedCurrencyValue = `${localizedCurrencyValue} ${currencyCode}`;
  }

  if (!hasNegativeParens || valueToFormat === 0) {
    return localizedCurrencyValue;
  }

  return `(${localizedCurrencyValue})`;
};
